import React from 'react';
import { UsageDataSource } from '../types';

interface DataSourceSelectorProps {
  dataSource: UsageDataSource;
  setDataSource: (source: UsageDataSource) => void;
  hasBothProviders: boolean;
  resolvedHasOpenAiKey: boolean;
  resolvedHasAnthropicKey: boolean;
  sourceDisplayName: string;
}

export const DataSourceSelector: React.FC<DataSourceSelectorProps> = React.memo(({
  dataSource,
  setDataSource,
  hasBothProviders,
  resolvedHasOpenAiKey,
  resolvedHasAnthropicKey,
  sourceDisplayName
}) => {
  if (hasBothProviders) {
    return (
      <div className="flex items-center gap-1 bg-slate-100 dark:bg-slate-800/60 rounded-lg p-0.5 border border-slate-200 dark:border-slate-700">
        {(['all', 'openai', 'anthropic'] as UsageDataSource[]).map(source => {
          const isActive = dataSource === source;
          const isAvailable = source === 'openai'
            ? resolvedHasOpenAiKey
            : source === 'anthropic'
              ? resolvedHasAnthropicKey
              : resolvedHasOpenAiKey || resolvedHasAnthropicKey;
          const label = source === 'all'
            ? 'All'
            : source === 'openai'
              ? 'OpenAI'
              : 'Anthropic';
          return (
            <button
              key={source}
              onClick={() => {
                if (!isActive && isAvailable) {
                  setDataSource(source);
                }
              }}
              disabled={!isAvailable}
              className={`px-2 py-0.5 text-xs font-medium rounded-md transition-colors ${
                isActive
                  ? 'bg-white dark:bg-slate-900 text-slate-900 dark:text-white shadow'
                  : 'text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700'
              } ${!isAvailable ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {label}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <span className="text-xs font-medium text-slate-700 dark:text-slate-200 px-1.5 py-0.5 bg-slate-100 dark:bg-slate-800/60 rounded">
      {sourceDisplayName}
    </span>
  );
});
DataSourceSelector.displayName = 'DataSourceSelector';
